import CalendarHomePage from '../components/calendar/CalendarHomePage'
import React from 'react'
import Private from './Private'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const Calendar = () => {
  const { t } = useTranslation()
  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('browser-header.calendar')}</title>
        <meta
          name="description"
          content="Office Free takvim ekranı ile daha önceden yaptığın tüm rezervasyonları görebilir, yaptığın rezervasyonları iptal edebilir veya boş günlerin için rezervasyon oluşturabilirsin."
        />
      </Helmet>
      <div className="container">
        <CalendarHomePage />
      </div>
    </Private>
  )
}

export default Calendar
